var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'youmi-en': _vm.isYOUMIEN, 'youmi-offers': _vm.isOFFERSYOUMI },attrs:{"id":"euler"},on:{"click":_vm.clickOutside}},[_c('layout',{ref:"layout"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }